import api from "../api/axios";


// =========================================
// PÚBLICO
// =========================================

export const obtenerAgendaPublica = () => {

    return api.get("/agenda");

};


export const obtenerAgendaPublicaPorId = (id) => {

    return api.get(`/agenda/${id}`);

};


// =========================================
// ADMIN
// =========================================

export const obtenerAgendaAdmin = () => {

    return api.get("/admin/agenda");

};


export const crearAgenda = (data) => {

    return api.post(
        "/admin/agenda",
        data
    );

};


export const actualizarAgenda = (id, data) => {

    return api.put(
        `/admin/agenda/${id}`,
        data
    );

};


export const eliminarAgenda = (id) => {

    return api.delete(
        `/admin/agenda/${id}`
    );

};